// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { LongWritesSuiCatalogueItem } from './LongWritesSuiCatalogueItem'
import {
  LongWritesSuiCatalogueItemFromJSON,
  LongWritesSuiCatalogueItemFromJSONTyped,
  LongWritesSuiCatalogueItemToJSON,
} from './LongWritesSuiCatalogueItem'

/**
 *
 * @export
 * @interface LongWritesSuiCatalogue
 */
export interface LongWritesSuiCatalogue {
  /**
   *
   * @type {Array<LongWritesSuiCatalogueItem>}
   * @memberof LongWritesSuiCatalogue
   */
  items?: Array<LongWritesSuiCatalogueItem> | null
}

/**
 * Check if a given object implements the LongWritesSuiCatalogue interface.
 */
export function instanceOfLongWritesSuiCatalogue(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LongWritesSuiCatalogueFromJSON(
  json: any,
): LongWritesSuiCatalogue {
  return LongWritesSuiCatalogueFromJSONTyped(json, false)
}

export function LongWritesSuiCatalogueFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LongWritesSuiCatalogue {
  if (json === undefined || json === null) {
    return json
  }
  return {
    items: !exists(json, 'items')
      ? undefined
      : json['items'] === null
        ? null
        : (json['items'] as Array<any>).map(LongWritesSuiCatalogueItemFromJSON),
  }
}

export function LongWritesSuiCatalogueToJSON(
  value?: LongWritesSuiCatalogue | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    items:
      value.items === undefined
        ? undefined
        : value.items === null
          ? null
          : (value.items as Array<any>).map(LongWritesSuiCatalogueItemToJSON),
  }
}
